import { render, staticRenderFns } from "./FrsExperimentalFeature.vue?vue&type=template&id=58b03836&scoped=true&lang=html&"
import script from "./FrsExperimentalFeature.vue?vue&type=script&lang=js&"
export * from "./FrsExperimentalFeature.vue?vue&type=script&lang=js&"
import style0 from "./FrsExperimentalFeature.vue?vue&type=style&index=0&id=58b03836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b03836",
  null
  
)

export default component.exports